import { useState, createContext } from "react";

export const DomainContext = createContext();

const DomainContextWrapper = (props) => {


  const [loading, setLoading] = useState(0);
  const [dataLoading, setDataLoading] = useState(0);

  const [searchArea, setToggleSearch] = useState(true);
  const [searchData, setSearchData] = useState({});
  const [customSearchData, setCustomSearchData] = useState({});
  const [searchTypes, setSearchTypes] = useState({});
  const [clearField, ToggleClearFeild] = useState(true);

  const [reloadTable, ToggleReloadTable] = useState(true)

  const handleSearchData = (key, val) => {

    setSearchData(prev => ({ ...prev, [key]: val }))
  }

  return <DomainContext.Provider value={{
    loading,
    setLoading,
    searchData,
    searchTypes,
    ToggleClearFeild,
    clearField,
    setSearchTypes,
    handleSearchData,
    setSearchData,
    dataLoading,
    setDataLoading,
    setToggleSearch,
    searchArea,
    customSearchData,
    setCustomSearchData,
    reloadTable,
    ToggleReloadTable
  }}>{props.children}</DomainContext.Provider>;
};

export default DomainContextWrapper;